// Provider routing groups — the SSOT for the op → group mapping.
//
// Each source op routes to exactly one provider group; within a group,
// providers are a priority list and the first to `claims(name)` owns the
// dataset. Both the source op (routing a name to a provider) and a
// provider (declaring which group it serves) reference these constants, so
// the routing key is defined once.

/** Group the `query` source op routes through (view-style datasets). */
export const KNOWLEDGE_GRAPH_GROUP = 'knowledge-graph';

/** Group the `datapoints` source op routes through (timeseries datasets). */
export const TIMESERIES_GROUP = 'timeseries';

/**
 * The head names of the dataset SOURCE ops — the special forms that open a
 * fresh row scope (each takes its own `(filter (fn [%] …))` predicate over
 * the dataset it names). SSOT for "is this op-call head a source op", shared
 * by the nested-sub-query pre-pass (which treats a source-op call in operand
 * position as an inner query) and the static column-ref walker (which stops
 * descending at a source-op call so an inner query's own row-scoped refs are
 * never validated against the enclosing query's schema).
 */
export const SOURCE_OP_NAMES: ReadonlySet<string> = new Set(['query', 'datapoints']);
